export class User {
  id?: number;
  firstName: string;
  lastName: string;
  fullName: string;
  initials: string;
  email: string;
  role: number;
  description?: string;
  avatar?: string;
  _isAdmin: boolean = false;

  constructor(user: any) {
    this.firstName = user?.firstName;
    this.lastName = user?.lastName;
    this.fullName = user?.firstName + ' ' + user?.lastName;
    this.initials = user?.firstName[0] + user?.lastName[0];
    this.email = user?.email;
    this.role = user?.role;
    this.description = user?.description;
    this.avatar = user?.avatar;
  }

  get isAdmin() {
    if (this._isAdmin === null) {
      this._isAdmin = this.role === 1;
    }

    return this._isAdmin;
  }
}